import { ref, computed, watch } from 'vue'

export function usePaginationQuickJump(currentPage, totalPages, goToPage) {
  const quickJumpPage = ref('')

  const isValidQuickJumpPage = computed(() => {
    const page = parseInt(quickJumpPage.value)
    return !isNaN(page) && page >= 1 && page <= totalPages.value && page !== currentPage.value
  })

  const handleQuickJump = () => {
    const page = parseInt(quickJumpPage.value)
    if (isValidQuickJumpPage.value) {
      goToPage(page)
      quickJumpPage.value = ''
    }
  }

  watch(currentPage, () => {
    quickJumpPage.value = ''
  })

  return {
    quickJumpPage,
    isValidQuickJumpPage,
    handleQuickJump
  }
}
